import axios from 'axios'
import _ from 'lodash'

// state
const state = {
  invalidToken: false,
  pageError: false,
  signatureData: {},
  showiFrame: false,
  loader: false,
}

const getters = {

}


// mutations
const mutations = {
  SET_VARIABLE(state, payload) {
    const { key, value } = payload;
    if (state.hasOwnProperty(key)) {
      state[key] = value;
    }
  },

	/**
	 * Clear variable
	 */
	RESET(state) {
    state.invalidToken = false;
    state.pageError = false;
    state.signatureData = {};
    state.showiFrame = false;
    state.loader = false;
	}

}

// actions
const actions = {
  setVariable({ commit }, payload) {
    commit('SET_VARIABLE', payload);
  },

  reset({ commit }) {
    commit('RESET');
  },

  /**
   * Check if job is still available
   */
  checkToken({ commit, dispatch, rootState }, data) {
    var url = rootState.auth.l + 'pandadoc-log/check-token';
    // pass it to api and check to make sure token exist & is not expired
    axios.post(url, data)
      .then(response => {
        if(response.data.status == 404){
          commit('SET_VARIABLE', {key: 'pageError', value: true});
          commit('SET_VARIABLE', {key: 'invalidToken', value: true});
        } else {
          commit('SET_VARIABLE', {key: 'signatureData', value: response.data.data});
          commit('SET_VARIABLE', {key: 'showiFrame', value: true});
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },

  /**
   * Send Compliances: this will send array of objects to API
   */
  generatePandaForm({commit, state, rootState}){
  	var header = rootState.auth.header;
    var url = rootState.auth.l+'v1/send-compliances/vendor';
    var currentVendorCompliance = rootState.compliance.currentVendorCompliance;

    let formData = new FormData();
    formData.append('vendor_id', currentVendorCompliance.vendor_id);
    formData.append('compliance_id', currentVendorCompliance.compliance_id);

    axios.post(url, formData, header).then(response => {
      commit('SET_VARIABLE', {key: 'loader', value: false})
      commit('SET_VARIABLE', {key: 'signatureData', value: response.data.data})
      VueStore.dispatch('notify/setVariable', { key: 'viewCompleteOnlineFormModal', value: true });
    }).catch( (error) => {
      console.log(error);
    });
  },

  /**
   * Refresh sidebar and compliance item
   */
  refresh({commit, rootState}){
    var currentVendorCompliance = rootState.compliance.currentVendorCompliance;
    VueStore.dispatch("compliance/getVendorCompliance", currentVendorCompliance.compliance_id);
    VueStore.dispatch("compliance/getCompliancesForSidebar", currentVendorCompliance.vendor_id);
  }


}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
